import { Spin } from 'antd';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  permission: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permission }) => {
  const { hasPermission, loading, isAuthenticated } = useAuth();

  if (loading) {
    // While the AuthGuard shows the main spinner, this prevents premature rendering of the outlet.
    // Returning a spinner here is a safe fallback.
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  // This check is important in case loading finishes but the user is somehow not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(permission)) {
    console.error(`Access denied. Missing permission: ${permission}`);
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
